import PropType from 'prop-types';
import React from 'react';

import { INSUFFICENT_MILES_CTA_EVENT, INSUFFICENT_MILES_MSG } from '../../utils/consts';

const InsufficientMiles = props => {
  const { closePopup } = props;

  return (
    <React.Fragment>
      <div className="spm_overlay spm_modal_overlay">
        <div className="ReactModal__Overlay ReactModal__Overlay--after-open">
          <div className="ReactModal__Content ReactModal__Content--after-open">
            <div className="insufficient_miles_wrapper">
              <div className="flex_row">
                <h4 className="heading">Insufficient Miles</h4>
                <div className="jp-popup-close-btn">
                  <button
                    type="button"
                    id="btnclose"
                    onClick={() => closePopup(INSUFFICENT_MILES_CTA_EVENT.CLOSE)}></button>
                </div>
              </div>
              <div className="jp-modal-details  jp-position-relative" aria-label="Verify your mobile">
                <div className="insufficient_miles_text status_text">
                  <p>{INSUFFICENT_MILES_MSG}</p>
                </div>
              </div>
              <div className="footer_section">
                <div className="button_container">
                  <div className="jp-button-container">
                    <button
                      type="button"
                      className="jp-button secondary no_text_transform"
                      onClick={() => closePopup(INSUFFICENT_MILES_CTA_EVENT.CANCEL)}>
                      Cancel
                    </button>
                  </div>
                  <div className="jp-button-container">
                    <button
                      type="button"
                      className="jp-button primary no_text_transform"
                      onClick={() => closePopup(INSUFFICENT_MILES_CTA_EVENT.PAY_VIA_INR)}>
                      Pay Via INR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

InsufficientMiles.propTypes = {
  closePopup: PropType.func,
};

export default InsufficientMiles;
